import _ from "lodash";
import {
  ACTIVITY_SEARCH_FORM_INIT,
  ACTIVITY_SEARCH_FORM_UPDATE,
  SINGLE_ACTIVITY_SEARCH_CHANGE,
  SINGLE_ACTIVITY_SEARCH_IDLE,
  SINGLE_ACTIVITY_SEARCH_LOADING,
  SINGLE_ACTIVITY_SEARCH_RESET,
  SINGLE_ACTIVITY_SEARCH_UPDATE,
  SINGLE_ACTIVITY_SELECTED_CHANGE,
  SINGLE_ACTIVITY_SELECTED_IDLE,
  SINGLE_ACTIVITY_SELECTED_LOADING,
  SINGLE_ACTIVITY_SELECTED_UPDATE,
  ACTIVITY_SEARCH_FILTERS_CHANGE,
  ACTIVITY_SEARCH_FILTERS_INIT,
  ACTIVITY_SEARCH_FILTERS_UPDATE,
  SINGLE_ACTIVITY_SELECTED_RESET,
} from "./types";

import { DateTime } from "luxon";
import {
  retrieveActivity,
  pollActivitiesSearch,
  searchRequestActivities,
} from "../../api/activities";
import { getDestQuickInfo, storeSearchSessionMetadata } from "../../api";
import { toast } from "react-toastify";
import { activitiesErrorMsgs } from "../../errors";

var api_key = import.meta.env.VITE_APP_WEBSITE_KEY;

export const singleActivitySearchLoading = () => {
  return { type: SINGLE_ACTIVITY_SEARCH_LOADING };
};
export const singleActivitySearchIdle = () => {
  return { type: SINGLE_ACTIVITY_SEARCH_IDLE };
};
export const singleActivitySearchFailed = () => {
  return { type: SINGLE_ACTIVITY_SEARCH_CHANGE, key: "failed", value: true };
};
export const updateSingleActivitySearchResult = ({ activities, loading }) => {
  return { type: SINGLE_ACTIVITY_SEARCH_UPDATE, activities, loading };
};
export const singleActivitySearchReset = () => {
  return { type: SINGLE_ACTIVITY_SEARCH_RESET };
};

export const activitySearchFormUpdate = ({ form }) => {
  return { type: ACTIVITY_SEARCH_FORM_UPDATE, form };
};
export const activitySearchFormReset = () => {
  return { type: ACTIVITY_SEARCH_FORM_INIT };
};

export const filtersUpdate = (filters) => {
  return { type: ACTIVITY_SEARCH_FILTERS_UPDATE, filters };
};
export const filtersReset = () => {
  return { type: ACTIVITY_SEARCH_FILTERS_INIT };
};
export const filtersChange = ({ key, value }) => {
  return { type: ACTIVITY_SEARCH_FILTERS_CHANGE, key, value };
};
export const searchResultsReset = () => {
  return { type: SINGLE_ACTIVITY_SEARCH_RESET };
};

export const selectedActivityLoading = () => {
  return { type: SINGLE_ACTIVITY_SELECTED_LOADING };
};
export const selectedActivityIdle = () => {
  return { type: SINGLE_ACTIVITY_SELECTED_IDLE };
};
export const selectedActivityFailed = () => {
  return { type: SINGLE_ACTIVITY_SELECTED_CHANGE, key: "failed", value: true };
};
export const selectedActivityUpdate = ({ data }) => {
  return { type: SINGLE_ACTIVITY_SELECTED_UPDATE, data };
};
export const selectedActivityReset = () => {
  return { type: SINGLE_ACTIVITY_SELECTED_RESET };
};

function sglActivitySearchPayloader({ form, source_entity, market_type }) {
  var output = {
    pax: {
      adults: form.adults,
      children: form.children,
      children_ages: form.children_ages,
    },
    date_from: DateTime.fromISO(form.date_from).toISODate(),
    date_to: DateTime.fromISO(form.date_to).toISODate(),
    latitude: form.latitude,
    longitude: form.longitude,
    radius: form.radius,
    website_api_key: api_key,
    source_entity,
    market_type,
  };

  return output;
}

export const activitySearchRequest =
  ({ source_entity, market_type, history, setLoadingSearchBtn }) =>
  async (dispatch, getState) => {
    const state = getState();
    const search_form = state.ActivitySearchForm;

    var destData = [];
    destData = await getDestQuickInfo({
      destinations: `${search_form.destination_meta.type}__${search_form.destination_meta.id}`,
    });

    const latitude = _.get(destData, "0.geodata.lat", 0);
    const longitude = _.get(destData, "0.geodata.lng", 0);

    if (!destData || latitude === 0 || longitude === 0) {
      toast.warning(activitiesErrorMsgs.searchForm.init_search, {
        duration: 3000,
      });
      dispatch(singleActivitySearchIdle());
      dispatch(singleActivitySearchFailed());
      setLoadingSearchBtn(false);
      return;
    }

    const payload = sglActivitySearchPayloader({
      form: {
        ...search_form,
        latitude,
        longitude,
      },
      source_entity,
      market_type,
    });

    dispatch(singleActivitySearchLoading());

    function onError() {
      toast.warning(activitiesErrorMsgs.searchForm.init_search, {
        duration: 3000,
      });
    }

    const resultsRequest = await searchRequestActivities({ payload, onError });
    if (!resultsRequest || !resultsRequest.session_id) {
      dispatch(singleActivitySearchIdle());
      dispatch(singleActivitySearchFailed());
      setLoadingSearchBtn(false);
      toast.warning(activitiesErrorMsgs.searchForm.init_search, {
        duration: 3000,
      });
      return;
    }

    const search_session_id = _.get(resultsRequest, "session_id", "");

    await dispatch(
      activitySearchFormUpdate({
        form: { ...search_form, search_session_id },
      })
    );

    const searchSessionResult = await storeSearchSessionMetadata({
      service_type: "ACT",
      session_data: { search_session_id, search_form },
    });

    if (
      _.isEmpty(_.get(searchSessionResult, "session_data", {})) ||
      !searchSessionResult.session_id
    ) {
      dispatch(singleActivitySearchIdle());
      dispatch(singleActivitySearchFailed());
      setLoadingSearchBtn(false);
      toast.warning(activitiesErrorMsgs.general.no_session, {
        duration: 3000,
      });
      return;
    }

    const { session_id: page_session_id } = searchSessionResult;

    if (search_session_id) {
      history.push(`/activities/${page_session_id}`);
    }

    return;
  };

export const activitySearchRequestPoller =
  ({ search_session_id, pollCount = 0 }) =>
  async (dispatch) => {
    if (!search_session_id) {
      return;
    }

    dispatch(singleActivitySearchLoading());

    const maxPollCount = 7;

    const poll_response = await pollActivitiesSearch({
      session_id: search_session_id,
    });

    function researcher() {
      const newPollCount = pollCount + 1;
      setTimeout(
        () =>
          dispatch(
            activitySearchRequestPoller({
              search_session_id,
              pollCount: newPollCount,
            })
          ),
        3000
      );
    }
    if (!poll_response && pollCount < maxPollCount) {
      researcher();
    } else if (
      poll_response === "system_error" ||
      (!poll_response && maxPollCount === pollCount)
    ) {
      dispatch(singleActivitySearchIdle());
      dispatch(singleActivitySearchFailed());
      toast.warning(
        poll_response === "system_error"
          ? activitiesErrorMsgs.general.no_session
          : activitiesErrorMsgs.resultsList.no_results,
        {
          duration: 3000,
        }
      );
      dispatch(selectedActivityReset());
    } else {
      const is_not_done = poll_response.status !== "done";
      dispatch(
        updateSingleActivitySearchResult({
          activities: {
            [search_session_id]: _.get(poll_response, "results", []),
          },
          loading: is_not_done,
        })
      );
      if (is_not_done) {
        researcher();
      }
    }
  };

export const singleActivitySelected =
  ({ activity_uid }) =>
  async (dispatch, getState) => {
    const state = getState();
    const { search_session_id } = state.ActivitySearchForm;

    const results = await retrieveActivity({ activity_uid, search_session_id });

    dispatch(selectedActivityLoading());

    if (_.isEmpty(results) || !results) {
      dispatch(selectedActivityFailed());
      dispatch(selectedActivityIdle());
      toast.warning(activitiesErrorMsgs.detailView.no_availability, {
        duration: 3000,
      });
      return false;
    }

    dispatch(
      selectedActivityUpdate({
        data: { activity: { ...results }, loading: false },
      })
    );

    return true;
  };
